/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * One-time code for the embedded strategy UI
 */
export interface StrategySessionDto {
  /**
   * One-time code, valid once and for a short time
   */
  code: string;
  /**
   * Lifetime of the code in seconds
   */
  expiresIn: number;
}
